jQuery(document).ready(function($) {

    var sH = $('.slider__images img.active').innerHeight();
    $('.slider__images').css('height', sH);


    $('.dropdown').on('click', function(e) {
        $(this).addClass('active');
        e.stopPropagation()
    });
    $(document).on('click', function(e) {
        if ($(e.target).is('dropdown') === false) {
            $('.dropdown').removeClass('active');
        }
    });

    $(window).resize(function(e) {
        if(window.innerWidth >= 1025 ) {
            $('.menu-modal').removeClass('active');
        }
        sH = $('.slider__images img.active').innerHeight();
        $('.slider__images').css('height', sH);
    });

    $(window).scroll(function() {
        var menu = $('.top__menu');
        var scroll = $(window).scrollTop();

        if(scroll > 40) {
            menu.addClass('sticky');
        } else {
            menu.removeClass('sticky');
        }

    });

    var slider = new Swiper('.slider__top', {
        navigation: {
            nextEl: '.slider__text .swiper-button-next',
            prevEl: '.slider__text .swiper-button-prev',
        },
        pagination: {
            el: '.slider__text .swiper-pagination',
        },
        autoplay: {
            delay: 5000,
        },
        on: {
            slideChange: function() {
                var currentSlide = slider.realIndex;
                $('.slider__images picture ').removeClass('active');
                $('.slider__images picture[data-slide="'+currentSlide+'"]').addClass('active');
            }
        }
    });

    var tem = new Swiper('.slider__tem', {
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.temoignages__slider .swiper-button-next',
            prevEl: '.temoignages__slider .swiper-button-prev',
        },
        pagination: {
            el: '.temoignages__slider .swiper-pagination',
        }
    });

});

console.log('%c  Made with ❤️ by https://cconcept.lu','' +
    '\n background: linear-gradient(to bottom, rgba(234,116,51,1) 0%,rgba(237,149,47,1) 100%);' +
    ' \n  color: white; \n  ' +
    'display: inline-block; \n  ' +
    'padding: 5px;\n  ' +
    'border-radius: 5px;\n '+
    'font-size: 12px;\n  ' +
    'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n    ');
